<script>
  import { auth } from '../firebase-settings'
  import { signInWithEmailAndPassword } from 'firebase/auth'
  import { navigate } from 'svelte-routing'

  let email, password

  $:passwordNotif = false

  let src = 'logo.svg'

  $:spinner = false

  let loginUser = async ({ email, password }) => {
    spinner = true
    try {
      let userCredential = await signInWithEmailAndPassword(auth, email, password)
      let user = userCredential.user
      console.log(user)
      localStorage.setItem('userId', user.uid)
      navigate('/home', { replace: true})
    } catch (err) {
      console.log(err)
      passwordNotif = true
    } finally {
      spinner = false
    }
    
  }
  import { Link } from 'svelte-routing'
</script>

<div class="flex bg-gray-100 items-center justify-center px-4 mx-aut py-24">
  <div class="w-full max-w-md">
    <form on:submit|preventDefault={e => loginUser({ email, password })} class="bg-white shadow-lg rounded-md px-12 pt-6 pb-8 mb-4">
      <div
        class="text-gray-800 text-2xl flex justify-center py-2 mb-4"
      >
        <img {src} alt="large pool mining" class="mx-auto w-44 h-24 object-fit" />
      </div>
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="username"
        >
          Email
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          name="email"
          v-model="form.email"
          type="email"
          required
          bind:value={email}
        />
      </div>
      <div class="mb-6">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="password"
        >
          Password
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
          v-model="form.password"
          type="password"
          placeholder="Password"
          name="password"
          bind:value={password}
          required
          autocomplete="current-password"
        />
        {#if passwordNotif}
          <h3 class="text-md text-red-600">Incorrect Password</h3>
        {/if}
      </div>
      <div class="flex items-center justify-between">
        
          {#if spinner} 
            <button class="px-4 py-2 rounded text-white inline-block shadow-lg bg-blue-500 hover:bg-blue-600 focus:bg-blue-700" type="submit">Sign In 
            <i class="fas fa-spinner ml-2 fa-spin"></i> </button>
          {:else}
            <button class="px-4 py-2 rounded text-white inline-block shadow-lg bg-blue-500 hover:bg-blue-600 focus:bg-blue-700" type="submit">Sign In 
            </button>
          {/if}
       
      </div>
      <a
          class="inline-block align-baseline font-normal text-sm text-blue-500 hover:text-blue-800"
          href="col"
        >
          Forgot Password?
        </a>
    </form>
    <p class="text-center text-gray-500 text-xs">
      &copy;2020 Gau Corp. All rights reserved.
    </p>
  </div>
</div>